<template>
    <m-slide-up :show="show" @close="() => $emit('close')">

        <div class="px-7">
            <h1 v-if="!showChangePasswordPop" class="font-bold text-xl">Change Password</h1>

            <div class="space-y-4 mt-4" v-if="!showChangePasswordPop">
                
                <m-form-group label="New Password" required>
                    <input type="password" class="form-control" placeholder="Enter new password" v-model="newPassword" />
                </m-form-group>
                <m-form-group label="Confirm New Password" required>
                    <input type="password" class="form-control" placeholder="Confirm new password" v-model="confirmNewPassword" />
                </m-form-group>

                <button class="btn-secondary w-full mt-5" @click="changePassword">Change Password</button>

            </div>

            <div v-else class="flex flex-col items-center justify-center h-full space-y-4">
                <div class="flex items-center justify-between">
                    <church-icon class="!w-20 !h-20 !text-green" icon="check-circle-solid" />
                </div>

                <p class="text-gray-1 px-7 text-center">Your password has been changed successfully.</p>

                <button class="btn-secondary w-full mt-5" @click="() => passwordChanged()">Close</button>
            </div>
        </div>
    </m-slide-up>
</template>

<script setup>
import UserApi from '@/apis/userApi';
import { ref, defineProps, defineEmits } from 'vue';

/* ============ PROPS ========== */
const props = defineProps({
    show: { type: Boolean, default: false },
    user : { type: Object, default: () => ({}) }
});


/* ========= EMITS ======== */
const emit = defineEmits(['close']);

/* ========= STATES ======== */
const newPassword = ref('');
const confirmNewPassword = ref('');
const showChangePasswordPop = ref(false);


/* ============ METHODS ========== */

/**
 * Reset states and emit close event
 */
const passwordChanged = () => {
    newPassword.value = '';
    confirmNewPassword.value = '';
    showChangePasswordPop.value = false;
    emit('close');
};

/**
 * Change password logic
 */
const changePassword = () => {
    const params = {
        user_id  : props.user?.ID || props.user?.user_id | props.user?.id,
        new_password : newPassword.value,
    }
   UserApi.changePassword({params, callback : () => {
    showChangePasswordPop.value = true;
   }})
};
</script>